import { Box, Typography } from '@mui/material';
import { t } from 'i18next';

interface UploadedFileProps {
    filename: string;
    url: string;
}

export const UploadedFile = ({ filename, url }: UploadedFileProps) => {
    return (
        <Box component="fieldset" sx={{ border: 'none', padding: 0, margin: 0 }}>
            {filename && url && (
                <Box sx={{ marginTop: 1, paddingLeft: '10px' }} role="status" aria-live="polite">
                    <Typography sx={{ fontWeight: 700, marginBottom: 0.5, fontSize: 12 }}>
                        {t('web_app.file_upload.uploaded_files')}
                    </Typography>
                    <ul style={{ margin: 0, paddingLeft: 0 }}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                marginBottom: 0.5,
                            }}
                        >
                            <Typography variant="body2" component="li">
                                <a href={url} target="_blank" rel="noreferrer">
                                    {filename}
                                </a>
                            </Typography>
                        </Box>
                    </ul>
                </Box>
            )}
        </Box>
    );
};
